import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Image , Checkbox , Icon } from 'semantic-ui-react';
import addInvoiceDisplay from '../../assets/feature/android/addInvoice.gif';
import addInvoiceIOSDisplay from '../../assets/feature/ios/addInvoice.gif';
import amendInvoiceDisplay from '../../assets/feature/android/amendInvoice.gif';
import amendInvoiceIOSDisplay from '../../assets/feature/ios/amendInvoice.gif';
import changeTableDisplay from '../../assets/feature/android/changeTable.gif';
import changeTableIOSDisplay from '../../assets/feature/ios/changeTable.gif';
import checkoutInvoiceDisplay from '../../assets/feature/android/checkoutInvoice.gif';
import checkoutInvoiceIOSDisplay from '../../assets/feature/ios/checkoutInvoice.gif';
import shareTableDisplay from '../../assets/feature/android/shareTable.gif';
import shareTableIOSDisplay from '../../assets/feature/ios/shareTable.gif';
import deleteInvoiceDisplay from '../../assets/feature/android/deleteInvoice.gif';
import deleteInvoiceIOSDisplay from '../../assets/feature/ios/deleteInvoice.gif';
import menuDisplay from '../../assets/feature/android/menu.gif';
import menuIOSDisplay from '../../assets/feature/ios/menu.gif';
import settingDisplay from '../../assets/feature/android/setting.gif';
import settingIOSDisplay from '../../assets/feature/ios/setting.gif';
import summaryDisplay from '../../assets/feature/android/summary.gif';
import summaryIOSDisplay from '../../assets/feature/ios/summary.gif';
import { bindActionCreators } from 'redux';
import { changeUiState } from '../../actions/uiActions';

const deviceDisplay = {
  android : {
    addInvoice : addInvoiceDisplay,
    amendInvoice : amendInvoiceDisplay,
    deleteInvoice : deleteInvoiceDisplay,
    changeTable : changeTableDisplay,
    checkoutInvoice : checkoutInvoiceDisplay,
    shareTable : shareTableDisplay,
    menu : menuDisplay,
    category : menuDisplay,
    item : menuDisplay,
    option : menuDisplay,
    set : menuDisplay,
    restaurant : settingDisplay,
    workflow : settingDisplay,
    staff : settingDisplay,
    serviceCharge : settingDisplay,
    discount : settingDisplay,
    printer : settingDisplay,
    floorPlan : settingDisplay,
    summary : summaryDisplay
  },
  ios : {
    addInvoice : addInvoiceIOSDisplay,
    amendInvoice : amendInvoiceIOSDisplay,
    deleteInvoice : deleteInvoiceIOSDisplay,
    changeTable : changeTableIOSDisplay,
    checkoutInvoice : checkoutInvoiceIOSDisplay,
    shareTable : shareTableIOSDisplay,
    menu : menuIOSDisplay,
    category : menuIOSDisplay,
    item : menuIOSDisplay,
    option : menuIOSDisplay,
    set : menuIOSDisplay,
    restaurant : settingIOSDisplay,
    workflow : settingIOSDisplay,
    staff : settingIOSDisplay,
    serviceCharge : settingIOSDisplay,
    discount : settingIOSDisplay,
    printer : settingIOSDisplay,
    floorPlan : settingIOSDisplay,
    summary : summaryIOSDisplay
  }
}

const styles = {
  deviceContainer : {
    display : 'flex',
    flexDirection : 'column',
    alignItems : 'center',
    position : 'relative'
  },
  deviceSwitch : {
    display : 'flex',
    flexDirection : 'row',
    alignItems : 'center',
    justifyContent : 'center'
  }
}

class DeviceDisplay extends Component {
  constructor(props){
    super(props);
    this.state = { device : 'android' }
  }
  render() {
    const { featureSelected , changeUiState } = this.props;
    const { device } = this.state;
    return (
      <Grid.Column only="computer" style={styles.deviceContainer} width={5}>
        <Grid>
          <Grid.Row style={{ padding : '0px' }}>
            <Grid.Column style={styles.deviceSwitch}>
              <Icon name='android' size='big' color='olive'/>
              <Checkbox toggle checked={(device === 'android') ? false : true } onClick={(event,{ checked })=>{ (checked) ? this.setState({ device : 'android' }) : this.setState({ device : 'ios' }) }}/>
              <Icon name='apple' size='big' color='grey'/>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ padding : '0px'}}>
            <Grid.Column style={{  display : 'flex' , flexDirection : 'column' , alignItems : 'center', justifyContent : 'center'   }}>
              <Image src={deviceDisplay[device][featureSelected]} style={{ width : '15%' , top : '30vh' , position : 'fixed' }}/>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    );
  }
}

function mapStateToProps(state) {
  return {
    device : state.ui.tempData.device
  }
}

const mapDispatchToProps = (dispatch)=>bindActionCreators({ changeUiState },dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(DeviceDisplay)



/** WEBPACK FOOTER **
 ** ./src/containers/features/deviceDisplay.js
 **/